import type { ToastIntent } from "@fluentui/react-components";
import { enqueueToast } from "./toastSlice";

export const showToast = (message: string, intent: ToastIntent = "info") => {
  const id = crypto.randomUUID();
  return enqueueToast({ id, message, intent });
};
